import React from 'react';
import { connect } from 'react-redux';
import { selectIsWindowMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectContentFirst } from '../_redux-scene';
import { selectIsGiftWindowOpen } from '../_redux-ui';
import { GiftWindowCompositionDesktop } from './desktop/GiftWindowCompositionDesktop';
import { GiftWindowCompositionMobile } from './mobile/GiftWindowCompositionMobile';
import { GiftWindowBody } from './shared/partials/GiftWindowBody';
import { GiftWindowProviderStack } from './shared/partials/GiftWindowProviderStack';
import styles from './GiftWindowStackItem.module.scss';

const _GiftWindowStackItem = ({ setIsOpen, isOpen, contentFirst }: Props) => {
    const isMobile = useMobile();

    if (!isOpen) {
        return null;
    }

    return (
        <WindowStackItem>
            <WindowContext.Provider fullHeight
                close={() => setIsOpen(false)}
                providerStack={GiftWindowProviderStack}
                bodyContainer={GiftWindowBody}
                className={contentFirst ? styles.contentFirstWindow : undefined}
                disableInteractionLock={contentFirst}>
                {isMobile ? (
                    <GiftWindowCompositionMobile onClose={() => setIsOpen(false)} />
                ) : (
                    <GiftWindowCompositionDesktop onClose={() => setIsOpen(false)} />
                )}
            </WindowContext.Provider>
        </WindowStackItem>
    );
};

type Props = {
    setIsOpen: (value: boolean) => void;
    isOpen: boolean;
    contentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    isOpen: selectIsGiftWindowOpen(state),
    isWindowMode: selectIsWindowMode(state),
    contentFirst: selectContentFirst(state)
});

export const GiftWindowStackItem = connect(
    mapStateToProps
)(_GiftWindowStackItem);